import { actions, types } from './requests'
export const GETBADGE_TYPES = {
    ...types('GETBADGE'),
}
export const GETBADGE_ACTIONS = {
    ...actions('GETBADGE'),
}